<template>
  <BaseVeeForm :action="submitForm" ensure-error-keys-camel-case>
    <template #default="formProps">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Payment method
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Code
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Cash</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <ValidationProvider name="cash" slim vid="paymentMethodToAccOrderPaymentMethod.cash">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput
                      type="text"
                      v-model="formData.paymentMethodToAccOrderPaymentMethod.cash"
                      :disabled="formProps.isPending"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              Cash on Delivery
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <ValidationProvider
                name="cash on delivery"
                slim
                vid="paymentMethodToAccOrderPaymentMethod.cod"
              >
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput
                      type="text"
                      v-model="formData.paymentMethodToAccOrderPaymentMethod.cod"
                      :disabled="formProps.isPending"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              Direct Bank Transfer
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <ValidationProvider
                name="direct bank transfer"
                slim
                vid="paymentMethodToAccOrderPaymentMethod.bacs"
              >
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput
                      type="text"
                      v-model="formData.paymentMethodToAccOrderPaymentMethod.bacs"
                      :disabled="formProps.isPending"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              Credit Card
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              <ValidationProvider
                name="credit card"
                slim
                vid="paymentMethodToAccOrderPaymentMethod.cc"
              >
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput
                      type="text"
                      v-model="formData.paymentMethodToAccOrderPaymentMethod.cc"
                      :disabled="formProps.isPending"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="w-40 px-6 py-4">
        <button
          type="submit"
          class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
          :disabled="formProps.isPending || formProps.invalid"
        >
          Update
        </button>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { softOneApiServiceConfigPaymentMethodsClient } from '@/api/clients';

const defaultFormData = {
  paymentMethodToAccOrderPaymentMethod: {
    cash: '',
    cod: '',
    bacs: '',
    cc: '',
  },
};

export default {
  props: {
    softOneServiceId: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      formData: {
        ...defaultFormData,
      },
    };
  },
  computed: {
    softOneApiService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.softOneServiceId];
    },
    currentPaymentMethodToAccOrderPaymentMethod() {
      const defaultData = defaultFormData.paymentMethodToAccOrderPaymentMethod;

      return this.softOneApiService?.config?.paymentMethodToAccOrderPaymentMethod || defaultData;
    },
  },
  created() {
    this.updateDefaultData();
  },
  methods: {
    updateDefaultData() {
      this.formData.paymentMethodToAccOrderPaymentMethod = {
        ...this.currentPaymentMethodToAccOrderPaymentMethod,
      };
    },
    async submitForm() {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.softOneServiceId,
          formData: { ...this.formData },
          service: softOneApiServiceConfigPaymentMethodsClient.update,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
